import UnauthenticatedApp from './UnauthenticatedApp';

export default UnauthenticatedApp;